import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-zinc-800" data-id="element-13">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-14">
        <span className="text-lg font-medium text-zinc-100 pr-8" data-id="element-15">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-orange-500 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-16" />
      </button>
      <AnimatePresence data-id="element-17">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-18">
            <div className="pb-6 text-zinc-400 leading-relaxed" data-id="element-19">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}